'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.configuration = window.configuration || {};

/**
 * Local project config.
 */

var ConfigStore = function () {
  function ConfigStore() {
    (0, _classCallCheck3.default)(this, ConfigStore);
  }

  (0, _createClass3.default)(ConfigStore, null, [{
    key: 'setConfig',

    /**
     * Set config object from local project
     * @param {object} config Key value data for configuration
     * @public
     *
     */
    value: function setConfig(config) {
      window.configuration = config;
    }

    /**
     * Get config entire config or by name
     *
     * @param  {String} path Optional path to value
     * @param  {Mixed} fallbackValue Optional path to value
     * @public
     *
     * @return {Mixed}      The requested config key value or the entire object if name is omitted
     */

  }, {
    key: 'getConfig',
    value: function getConfig() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var fallbackValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (path === undefined) {
        return window.configuration;
      }

      return (0, _lodash.get)(window.configuration, path, fallbackValue);
    }
  }]);
  return ConfigStore;
}();

exports.default = ConfigStore;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/ConfigStore.js
// module id = 279
// module chunks = 0